/* MySpirulina, Anbau-Garantie
   Legt die Anbau-Garantie automatisch in den Warenkorb, sobald das Starter-Kit
   darin liegt, und entfernt sie wieder, sobald das Starter-Kit fehlt.

   Reihenfolge: die Garantie wird im selben cart/add als erstes Item mitgeschickt,
   das Starter-Kit als zweites. Shopify zeigt die zuletzt angelegte Zeile oben,
   daher steht das Kit im Checkout oben. Ein Request verhindert doppelte AddToCart-
   Pixel. Im Warenkorb und im Drawer schiebt das Skript die Garantie zusaetzlich
   per DOM direkt unter das Starter-Kit.

   Das Produkt ist Unlisted, zusaetzlich werden hier die Links aus der
   Warenkorbzeile entfernt, damit niemand auf die Produktseite kommt.

   Starter-Kit-Zeile: bekommt die Klasse ms-kit-item und am Produktnamen
   (.cart-item__name) das Attribut data-ms-kit-note (Bestandteile), das CSS
   zeigt es als Zeile unter dem Namen an.

   Konfiguration kommt aus snippets/ms-anbau-garantie.liquid (window.msAnbauGarantie).
*/
(function () {
  'use strict';

  var config = window.msAnbauGarantie || {};
  var GIFT_ID = Number(config.giftVariantId || 0);
  var GIFT_HANDLE = config.giftHandle || '';
  var KIT_NOTE = config.kitNote || '';
  var TRIGGERS = (config.triggerVariantIds || []).map(Number).filter(Boolean);
  if (!GIFT_ID || !TRIGGERS.length || !window.fetch) return;

  var nativeFetch = window.fetch.bind(window);
  var routes = window.routes || {};
  var ADD_URL = routes.cart_add_url || '/cart/add';
  var CHANGE_URL = routes.cart_change_url || '/cart/change';
  var CART_URL = routes.cart_url || '/cart';
  var RELOAD_FLAG = 'msGarantieReload';

  var busy = false;
  var queued = false;
  var moving = false;
  var timer = null;

  function post(url, data) {
    return nativeFetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    });
  }

  function getCart() {
    return nativeFetch(CART_URL + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function isTrigger(id) {
    return TRIGGERS.indexOf(Number(id)) !== -1;
  }

  /* Liest die Varianten-IDs aus einem Add-Request, egal in welchem Format */
  function idsFromBody(body) {
    var ids = [];
    function collect(key, value) {
      if (key === 'id' || /^items\[\d+\]\[id\]$/.test(key)) ids.push(value);
    }
    try {
      if (!body) return ids;
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        body.forEach(function (value, key) { collect(key, value); });
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        body.forEach(function (value, key) { collect(key, value); });
      } else if (typeof body === 'string') {
        var trimmed = body.replace(/^\s+/, '');
        if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
          var data = JSON.parse(trimmed);
          var list = data && data.items ? data.items : [data];
          for (var i = 0; i < list.length; i++) {
            if (list[i] && list[i].id != null) ids.push(list[i].id);
          }
        } else {
          new URLSearchParams(body).forEach(function (value, key) { collect(key, value); });
        }
      }
    } catch (e) {}
    return ids;
  }

  function giftItem() {
    return { id: GIFT_ID, quantity: 1, properties: { _internal: 'anbau-garantie' } };
  }

  function cartHasGift(cart) {
    return (cart.items || []).some(function (item) { return item.variant_id === GIFT_ID; });
  }

  function parseAddBody(body) {
    var items = [];
    var extra = {};
    var props = {};
    var single = { id: null, quantity: 1, selling_plan: '', properties: props };

    function takeExtra(key, value) {
      if (key === 'sections' || key === 'sections_url') extra[key] = value;
    }

    try {
      if (!body) return { items: items, extra: extra };
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        body.forEach(function (value, key) {
          takeExtra(key, value);
          if (key === 'id') single.id = value;
          else if (key === 'quantity') single.quantity = value;
          else if (key === 'selling_plan') single.selling_plan = value;
          else {
            var match = String(key).match(/^properties\[([^\]]+)\]$/);
            if (match) props[match[1]] = value;
          }
        });
        if (single.id) {
          var item = { id: single.id, quantity: single.quantity || 1 };
          if (single.selling_plan) item.selling_plan = single.selling_plan;
          if (Object.keys(props).length) item.properties = props;
          items.push(item);
        }
      } else if (typeof body === 'string') {
        var trimmed = body.replace(/^\s+/, '');
        if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
          var data = JSON.parse(trimmed);
          if (data && data.items) {
            items = data.items.slice();
          } else if (data && data.id != null) {
            items = [{ id: data.id, quantity: data.quantity || 1 }];
            if (data.selling_plan) items[0].selling_plan = data.selling_plan;
            if (data.properties) items[0].properties = data.properties;
          }
          if (data && data.sections) extra.sections = data.sections;
          if (data && data.sections_url) extra.sections_url = data.sections_url;
        } else {
          var params = new URLSearchParams(body);
          var parsedId = params.get('id');
          if (parsedId) {
            var parsedItem = { id: parsedId, quantity: params.get('quantity') || 1 };
            if (params.get('selling_plan')) parsedItem.selling_plan = params.get('selling_plan');
            items.push(parsedItem);
          }
          if (params.get('sections')) extra.sections = params.get('sections');
          if (params.get('sections_url')) extra.sections_url = params.get('sections_url');
        }
      }
    } catch (e) {}
    return { items: items, extra: extra };
  }

  function mergeGiftIntoAdd(args) {
    return getCart()
      .then(function (cart) {
        if (cartHasGift(cart)) return nativeFetch.apply(window, args);

        var input = args[0];
        var init = Object.assign({}, args[1] || {});
        var parsed = parseAddBody(init.body);
        if (!parsed.items.length) return nativeFetch.apply(window, args);

        parsed.items.unshift(giftItem());
        var payload = { items: parsed.items };
        if (parsed.extra.sections) payload.sections = parsed.extra.sections;
        if (parsed.extra.sections_url) payload.sections_url = parsed.extra.sections_url;

        var headers = Object.assign({}, init.headers || {});
        headers['Content-Type'] = 'application/json';
        if (!headers['Accept'] && !headers.accept) headers['Accept'] = 'application/javascript';
        init.headers = headers;
        init.method = 'POST';
        init.body = JSON.stringify(payload);

        return nativeFetch(input, init).then(function (res) {
          if (res && res.ok) return res;
          return nativeFetch.apply(window, args);
        });
      })
      .catch(function () {
        return nativeFetch.apply(window, args);
      });
  }

  function ensureGiftFirst() {
    return getCart()
      .then(function (cart) {
        if (cartHasGift(cart)) return null;
        return post(ADD_URL, { items: [giftItem()] });
      })
      .catch(function () { return null; });
  }

  function sync() {
    return getCart().then(function (cart) {
      var gift = null;
      var hasTrigger = false;
      (cart.items || []).forEach(function (item) {
        if (item.variant_id === GIFT_ID) gift = item;
        if (isTrigger(item.variant_id)) hasTrigger = true;
      });

      if (hasTrigger && !gift) {
        return post(ADD_URL, { items: [giftItem()] }).then(function () { return true; });
      }
      if (hasTrigger && gift && gift.quantity !== 1) {
        return post(CHANGE_URL, { id: gift.key, quantity: 1 }).then(function () { return true; });
      }
      if (!hasTrigger && gift) {
        return post(CHANGE_URL, { id: gift.key, quantity: 0 }).then(function () { return true; });
      }
      return false;
    });
  }

  function onCartPage() {
    var here = window.location.pathname.replace(/\/+$/, '');
    var cart = CART_URL.replace(/\/+$/, '');
    return here === cart;
  }

  function reloadOnce() {
    try {
      if (window.sessionStorage.getItem(RELOAD_FLAG) === '1') return;
      window.sessionStorage.setItem(RELOAD_FLAG, '1');
    } catch (e) {}
    window.location.reload();
  }

  function clearReloadFlag() {
    try { window.sessionStorage.removeItem(RELOAD_FLAG); } catch (e) {}
  }

  function refreshCartPage() {
    return nativeFetch(CART_URL + '?section_id=cart-items')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var source = doc.querySelector('cart-items');
        var target = document.querySelector('cart-items');
        if (!source || !target) throw new Error('cart section missing');
        target.replaceWith(source);
        mark();
      })
      .catch(function () { reloadOnce(); });
  }

  function refreshBubble() {
    nativeFetch(window.location.pathname + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var source = doc.querySelector('.shopify-section') || doc.body;
        var target = document.querySelector('#cart-icon-bubble');
        if (source && target) target.innerHTML = source.innerHTML;
      })
      .catch(function () {});
  }

  function refresh() {
    if (onCartPage()) {
      refreshCartPage();
      refreshBubble();
      return;
    }
    var items = document.querySelector('cart-drawer-items');
    if (items && typeof items.onCartUpdate === 'function') {
      try { items.onCartUpdate(); } catch (e) {}
    }
    refreshBubble();
  }

  function unlink(row) {
    var links = row.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (href.indexOf('/products/') !== -1 || (GIFT_HANDLE && href.indexOf(GIFT_HANDLE) !== -1)) {
        links[i].removeAttribute('href');
        links[i].removeAttribute('target');
        links[i].setAttribute('role', 'text');
      }
    }
  }

  function rowFor(scope, variantId) {
    var node = scope.querySelector('[data-variant-id="' + variantId + '"], [data-quantity-variant-id="' + variantId + '"]');
    var row = node && node.closest ? node.closest('.cart-item') : null;
    return row && row.parentNode === scope ? row : null;
  }

  function reorder() {
    var gifts = document.querySelectorAll('.cart-item.ms-garantie-item');
    for (var i = 0; i < gifts.length; i++) {
      var gift = gifts[i];
      var scope = gift.parentNode;
      if (!scope) continue;
      var trigger = null;
      for (var t = 0; t < TRIGGERS.length; t++) {
        var candidate = rowFor(scope, TRIGGERS[t]);
        if (candidate) trigger = candidate;
      }
      if (trigger && trigger !== gift && trigger.nextElementSibling !== gift) {
        moving = true;
        try {
          if (trigger.after) { trigger.after(gift); }
          else { scope.insertBefore(gift, trigger.nextSibling); }
        } catch (e) {}
        moving = false;
      }
    }
  }

  function markKit() {
    if (!KIT_NOTE) return;
    for (var t = 0; t < TRIGGERS.length; t++) {
      var nodes = document.querySelectorAll('[data-variant-id="' + TRIGGERS[t] + '"], [data-quantity-variant-id="' + TRIGGERS[t] + '"]');
      for (var i = 0; i < nodes.length; i++) {
        var row = nodes[i].closest ? nodes[i].closest('.cart-item') : null;
        if (!row) continue;
        row.classList.add('ms-kit-item');
        var name = row.querySelector('.cart-item__name');
        if (name && name.getAttribute('data-ms-kit-note') !== KIT_NOTE) {
          name.setAttribute('data-ms-kit-note', KIT_NOTE);
        }
      }
    }
  }

  function mark() {
    var nodes = document.querySelectorAll('[data-variant-id="' + GIFT_ID + '"], [data-quantity-variant-id="' + GIFT_ID + '"]');
    for (var i = 0; i < nodes.length; i++) {
      var row = nodes[i].closest ? nodes[i].closest('.cart-item') : null;
      if (!row) continue;
      row.classList.add('ms-garantie-item');
      unlink(row);
    }
    markKit();
    reorder();
  }

  function reconcile() {
    if (busy) { queued = true; return; }
    busy = true;
    sync()
      .then(function (changed) {
        busy = false;
        if (queued) { queued = false; reconcile(); return; }
        if (changed) { refresh(); } else { clearReloadFlag(); }
        mark();
      })
      .catch(function () { busy = false; });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(reconcile, 150);
  }

  window.fetch = function () {
    var args = arguments;
    var url = '';
    var method = 'GET';
    var body = null;
    try {
      var input = args[0];
      var init = args[1];
      url = typeof input === 'string' ? input : (input && input.url) || '';
      method = (init && init.method) || (input && input.method) || 'GET';
      body = init && init.body !== undefined ? init.body : null;
    } catch (e) {}

    var isPost = String(method).toUpperCase() === 'POST';
    var isAdd = isPost && /\/cart\/add(\.js)?($|\?)/.test(url);
    var isChange = isPost && /\/cart\/(change|update)(\.js)?($|\?)/.test(url);

    if (isAdd) {
      var ids = idsFromBody(body);
      var addsTrigger = false;
      for (var i = 0; i < ids.length; i++) {
        if (isTrigger(ids[i])) addsTrigger = true;
      }
      if (addsTrigger) {
        /* One cart/add for gift + kit so pixels fire a single AddToCart */
        var call = mergeGiftIntoAdd(args);
        call.then(function () { schedule(); }).catch(function () {});
        return call;
      }
    }

    var result = nativeFetch.apply(window, args);
    if (isAdd || isChange) {
      result.then(function () { schedule(); }).catch(function () {});
    }
    return result;
  };

  var observer = new MutationObserver(function () {
    if (moving) return;
    mark();
  });

  function start() {
    mark();
    schedule();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
